/**
 * Single active guard for in-app admin navigation (gig sidebar tabs, header links, mode tabs).
 * A guard receives `proceed` and returns true when it has taken over (e.g. opened a
 * confirm dialog that will call `proceed` later); returning false lets navigation continue.
 */
let activeGuard = null;

export const registerNavigationGuard = (guard) => {
  activeGuard = guard;
  return () => {
    if (activeGuard === guard) activeGuard = null;
  };
};

export const guardedNavigate = (proceed) => {
  if (typeof activeGuard === "function" && activeGuard(proceed) === true) return;
  proceed();
};
